import { FC, ReactNode } from 'react';

export type DrawerContentLayoutProps = {
  buttonItems: ReactNode[];
  mainContent: ReactNode;
};

export const DrawerContentLayout: FC<DrawerContentLayoutProps> = ({
  buttonItems,
  mainContent,
}) => (
  <div className="flex h-full flex-col justify-between">
    <div className="flex flex-1 flex-col overflow-y-auto p-6">
      {mainContent}
    </div>
    <div className="flex flex-row justify-end gap-4 border-t border-gray-200 p-4">
      {buttonItems}
    </div>
  </div>
);
